export const selectArticles = (state) => state.articles.all || [];
export const selectCurrentArticle = (state) => state.articles?.current || null;
export const selectIsLoading = (state) => state.articles.isLoading;
export const selectLastArticle = (state) => state.articles.last || null;
export const selectArticleCount = (state) => state.articles.count || 0;
